// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';
const ROOTS_CHANNEL = '/channel';
const ROOTS_CONTACT = '/contact';
const ROOTS_SERVICES = '/services';
const ROOTS_PBX = '/pbx';
const ROOTS_TICKET = '/ticket';
const ROOTS_CONFIGURATION = '/configuration';
const ROOTS_STATISTIC = '/statistic';
const ROOTS_STAFF = '/staff';
// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
  settings: '/settings'
};
export const PATH_CONTACT = {
  root: ROOTS_CONTACT,
  contact: {
    staff: path(ROOTS_STAFF, '/list'),
    contactlist: path(ROOTS_CONTACT, '/list'),
    upload: path(ROOTS_DASHBOARD, '/upload')
  },
}
export const PATH_CONFIGURATION = {
  root: ROOTS_CONFIGURATION,

}
export const PATH_TICKET = {
  root: ROOTS_TICKET,
  ticket: {
    list: path(ROOTS_TICKET, '/list'),
  }
}
export const PATH_SERVICES = {
  root: ROOTS_SERVICES,
  services: {
    smszns: path(ROOTS_SERVICES, '/smszns'),
    queue: path(ROOTS_SERVICES, '/smszns/queue')
  },
}
export const PATH_PBX = {
  root: ROOTS_PBX,
  pbx: {
    callhistory: path(ROOTS_PBX, '/callhistory')
  }
}
export const MULTI_CHANNEL = {
  root: ROOTS_CHANNEL,
  live_chat: {
    root: path(ROOTS_CHANNEL, '/livechat'),
    chat: path(ROOTS_CHANNEL, '/livechat/chat'),
  },
  facebook: {
    root: path(ROOTS_CHANNEL, '/facebook'),
    pages: path(ROOTS_CHANNEL, '/facebook/pages'),
    status: path(ROOTS_CHANNEL, '/facebook/status'),
    chat: path(ROOTS_CHANNEL, '/facebook/chat'),
    setting: path(ROOTS_CHANNEL, '/facebook/setting'),
  },
  zalo: {
    root: path(ROOTS_CHANNEL, '/zalo'),
    chat: path(ROOTS_CHANNEL, '/zalo/chat'),
    setting: path(ROOTS_CHANNEL, '/zalo/setting'),
  },
}
export const PATH_STATISTIC = {
  root: ROOTS_STATISTIC,

}
export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,

  mail: {
    root: path(ROOTS_DASHBOARD, '/mail'),
    all: path(ROOTS_DASHBOARD, '/mail/all')
  },
  contact: {
    root: path(ROOTS_DASHBOARD, 'contact'),
    all: path(ROOTS_DASHBOARD, '/contact/upload')
  },
  chat: {
    root: path(ROOTS_DASHBOARD, '/chat'),
    new: path(ROOTS_DASHBOARD, '/chat/new'),
    conversation: path(ROOTS_DASHBOARD, '/chat/:conversationKey')
  },
  calendar: path(ROOTS_DASHBOARD, '/calendar'),
  kanban: path(ROOTS_DASHBOARD, '/kanban'),
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    list: path(ROOTS_DASHBOARD, '/user/list'),
    newUser: path(ROOTS_DASHBOARD, '/user/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  eCommerce: {
    root: path(ROOTS_DASHBOARD, '/e-commerce'),
    shop: path(ROOTS_DASHBOARD, '/e-commerce/shop'),
    product: path(ROOTS_DASHBOARD, '/e-commerce/product/:name'),
    productById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-air-force-1-ndestrukt'),
    list: path(ROOTS_DASHBOARD, '/e-commerce/list'),
    newProduct: path(ROOTS_DASHBOARD, '/e-commerce/product/new'),
    editById: path(ROOTS_DASHBOARD, '/e-commerce/product/nike-blazer-low-77-vintage/edit'),
    checkout: path(ROOTS_DASHBOARD, '/e-commerce/checkout'),
    invoice: path(ROOTS_DASHBOARD, '/e-commerce/invoice')
  },
  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post')
  }
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
